<div class="inner-content" *transloco="let t; read: 'chooseGroupModal'">
    <div class="wrapper-request" *ngIf="!requestSuccess">
        <div class="title" *ngIf="!isParentRole">
            {{ t('childTitle') }}
        </div>

        <div class="title" *ngIf="isParentRole">
            {{ t('parentTitle') }}
        </div>

        <form (submit)="onSubmit()" [formGroup]="requestForm" class="">

            <div class="form-group">

                <ion-input class="input-field contact-name" inputmode="text"
                           [attr.aria-label]=" 'registerPage.name'|transloco"
                           placeholder="{{  'registerPage.name'|transloco }}" labelPlacement="stacked"
                           formControlName="contactName"
                           label-placement="floating" fill="outline"></ion-input>

                <div ngForm="telInputBlock" class="form-tel">
                    <intl-tel-input
                        [name]="'phone'"
                        [cssClass]="'form-group-control phone'"
                        [labelCssClass]="'col-sm-2 col-form-label'"
                        [required]="true"
                        [options]="{
                    preferredCountries: ['ua'],
                    initialCountry:'ua',
                    autoPlaceholder:'off',
                    separateDialCode:true
                  }"
                        [(E164PhoneNumber)]="contactPhone"

                    ></intl-tel-input>


                </div>

                <div class="contact-way-wrapper input-field">

                    <div *ngFor="let contact of CONTACT_WAYS; let i=index" class="col-md-2">

                        <ion-checkbox labelPlacement="end" class="contact-way"
                                      [value]="contact.value" (ionChange)="onCheckChange($event)">
                            {{ contact.value == 'Дзвінок' ? (contact.label | transloco) : contact.label }}


                        </ion-checkbox>
                    </div>

                </div>


                <button type="submit" class="btn dark-btn"> {{ t('send') }}</button>


            </div>

        </form>


        <div class="close" (click)="close()">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M8.26035 8.26035C8.60748 7.91322 9.1703 7.91322 9.51743 8.26035L16 14.743L22.4826 8.26041C22.8297 7.91327 23.3925 7.91327 23.7396 8.26041C24.0868 8.60754 24.0868 9.17035 23.7397 9.51749L17.2571 16L23.7396 22.4825C24.0867 22.8296 24.0867 23.3925 23.7396 23.7396C23.3925 24.0867 22.8296 24.0867 22.4825 23.7396L16 17.2571L9.51749 23.7397C9.17036 24.0868 8.60754 24.0868 8.26041 23.7397C7.91328 23.3925 7.91328 22.8297 8.26041 22.4826L14.7429 16L8.26035 9.51743C7.91322 9.1703 7.91322 8.60748 8.26035 8.26035Z"
                      fill="#83B25F"/>
            </svg>

        </div>


    </div>

    <div class="wrapper-success" *ngIf="requestSuccess">

        <div *ngIf="!isParentRole" class="info">
            <div class="title"> {{ t('requestSent') }}</div>
            <div class="text"> {{ t('requestSentText') }}</div>
        </div>

        <div *ngIf="isParentRole" class="info">
            <div class="title">{{ t('requestSent') }}</div>
            <div class="text">{{ t('requestSentTextParent') }}
            </div>
        </div>

        <div class="close" (click)="close()">
            <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M42.374 17.6257L17.6253 42.3745" stroke="#3F403F" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M17.626 17.6257L42.3747 42.3745" stroke="#3F403F" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round"/>
            </svg>

        </div>
    </div>


</div>
